import { AlertFactory } from 'alerts/Alert'
import DocumentStore, {
  type UploadDocumentRequest,
} from 'documents/DocumentStore'
import DocumentTypeStore from 'documents/DocumentTypeStore'
import { DocumentActionsAdapter } from 'documents/DocumentActionsAdapter'
import Job from 'jobs/Job'
import DocumentType from 'documents/DocumentType'
import { computed, makeObservable } from 'mobx'
import { Id } from 'types/definitions'

/**
 * Adapter for Job Documents
 */
export class JobDocumentsAdapter {
  constructor(
    private documentStore: DocumentStore,
    private documentTypeStore: DocumentTypeStore,
    public documentActionsAdapter: DocumentActionsAdapter,
    public newAlert: AlertFactory,
  ) {
    makeObservable(this)
  }

  @computed
  get documentTypes() {
    return this.documentTypeStore.types
  }

  getJobDocuments(jobId: string) {
    return this.documentStore.forJob(jobId)
  }

  getScrollProvider(jobId: string) {
    return this.documentStore.getScrollProvider(jobId, (params) =>
      this.documentStore.searchDocuments({
        context: 'Job',
        jobId,
        ...params,
      }),
    )
  }

  makeUploadRequest(
    file: File,
    job: Job,
    type: DocumentType | undefined,
  ): UploadDocumentRequest {
    return {
      file,
      workspaceId: Id.assert(job.workspace.id),
      jobId: Id.assert(job.id),
      documentTypeId: type ? Id.assert(type.id) : undefined,
    }
  }
}
